import useBaseCreate from "../useBaseCreate";
import {
    HelpTopic,
    InitializeHelpTopicRequest,
    InitializeHelpTopicResponse,
    HelpTopicMetadataContext,
} from "src/api/Tmd.dtos";
import type { SWRConfiguration } from "swr";

const useHelpTopicCreate = (
    context?: Partial<HelpTopicMetadataContext> | null,
    configuration?: SWRConfiguration<
        InitializeHelpTopicResponse,
        InitializeHelpTopicResponse
    > | null,
) =>
    useBaseCreate<
        HelpTopic,
        Partial<HelpTopicMetadataContext>,
        InitializeHelpTopicResponse,
        InitializeHelpTopicRequest
    >(InitializeHelpTopicRequest, context, configuration);

export default useHelpTopicCreate;
